import { Link } from "react-router-dom";
import { Player } from "video-react";
import {
  pauseVideo,
  playVideo,
  stopProps,
} from "./simulationVideoHandlers";

const SimulationCard = ({
  data,
  detailPath,
  actionLabel = "Learn More »",
  showAction = () => true,
  showDownloadOverviews = false,
  downloadOverviewsHref = "https://content.schoolsims.com/request-simulation-overviews",
}) => {
  const hasPreview = Boolean(data.preview);
  const thumbnail = data.thumbnail ? `/images/${data.thumbnail}` : null;
  const showActionButton = showAction(data);

  return (
    <div>
      {hasPreview && (
        <div className="simulation-blanket" onClick={pauseVideo}>
          <div className="simulation-video-box">
            <div className="close-section">
              CLOSE <i className="fa fa-times"></i>
            </div>
            <div className="inner">
              <div className="embed-container">
                <Player
                  className="simulation-video"
                  playsInline
                  src={`/video/${data.preview}`}
                  onClick={stopProps}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="simulation hidden2" data-cats="All Simulations ">
        <div
          className="poster sim_2"
          style={
            thumbnail ? { backgroundImage: `url(${thumbnail})` } : undefined
          }
          onClick={hasPreview ? playVideo : undefined}
        >
          {hasPreview && (
            <div className="playhead">
              <div className="icon">
                <i className="fa fa-play-circle" />
              </div>
              <div className="playhead-title">Preview</div>
            </div>
          )}
        </div>
        <div className="content">
          <div className="simulation-title">{data.simName}</div>
          <div className="runtime">~{data.simDuration}</div>
          <div className="excerpt">
            <p className="fields-font">
              <span className="sim-detail-description">{data.description}</span>
            </p>
          </div>

          {(showDownloadOverviews || showActionButton) && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "10px",
            }}
          >
            {showDownloadOverviews && (
              <>
                <hr />
                <a
                  href={downloadOverviewsHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Simulation Overviews
                </a>
              </>
            )}
            {showActionButton && (
              <Link
                className="btn white"
                style={{ alignSelf: "center" }}
                to={detailPath(data.simId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {actionLabel}
              </Link>
            )}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimulationCard;
